import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    accountCategoryList: () => {
        return HTTP.get('/account/ac_group_list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}